import type {SVGProps} from 'react';

type VisorEmblemLogoProps = SVGProps<SVGSVGElement>;

/** Эмблема Visor — копия Icons.logo с visor_landing_v2 */
export function VisorEmblemLogo(props: VisorEmblemLogoProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="61"
            viewBox="0 0 64 61"
            fill="none"
            {...props}
        >
            <path d="M30.4375 58.2656V35.7656L0.4375 5.76562L30.4375 58.2656Z" fill="currentColor"/>
            <path d="M35.9375 52.2656L53.4375 23.2656L5.4375 3.26562L35.4375 34.2656L35.9375 52.2656Z" fill="currentColor"/>
            <path d="M47.9375 16.7656L35.4375 11.2656L48.4375 5.26562L45.4375 0.765625L62.9375 4.76562L55.9375 17.7656L52.9375 13.2656L47.9375 16.7656Z" fill="currentColor"/>
        </svg>
    );
}
